module.exports = "<div class=\"card\">\n  <div class=\"card-content\">\n    <h1>{{ 'ACCOUNT' | translate }}</h1>\n    <i class=\"icon fas fa-pen\" (click)=\"openDialog()\"></i>\n    <hr>\n    <div *ngIf=\"user\">\n      <h2>{{user.name}}</h2>\n      <p class=\"email\">{{user.email}}</p>\n      <p>{{ 'ROLE' | translate }}: {{rolesString}}</p>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/components/user-info/user-info.component.html
// module id = 1410
// module chunks = 0